import { CHANNEL_SEGMENT } from '@/models/virtualClinic'

const queueAdultLength = state => {
  const adult = state.queue?.filter(
    data => data.segment === CHANNEL_SEGMENT.ADULT
  )

  return adult?.length || 0
}

const queuePediatricLength = state => {
  const pediatric = state.queue?.filter(
    data => data.segment === CHANNEL_SEGMENT.PEDIATRIC
  )

  return pediatric?.length || 0
}

export default {
  queueAdultLength,
  queuePediatricLength
}
